import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { MatTableDataSource } from "@angular/material";
import { ConvertUpochToDate } from "src/_helpers/utils";
import { OpenBet } from "src/_models";
import { EventService } from "src/_services/event.service";

@Component({
  selector: "event-open-bets",
  templateUrl: "./open-bets.component.html",
  styleUrls: ["./open-bets.component.scss"],
})
export class EventOpenBetsComponent {
  @Input() openBets: MatTableDataSource<OpenBet[]>;

  displayedColumns: string[] = ["User", "BetTime", "BetOn", "Odds", "Stake"];

  constructor(private eventService: EventService) {}

  convertUpochToDate(date: number) {
    return ConvertUpochToDate(date);
  }
}
